export const iconsList = [
  {
    label: "Mailing list",
    name: "envelope-open",
    color: "#44b1ff"
  },
  {
    label: "External link",
    name: "external-link",
    color: "#000000"
  },
  {
    label: "Podcast",
    name: "podcast",
    color: "#D56DFB"
  },
  {
    label: "Shopping cart",
    name: "shopping-cart",
    color: "#000000"
  },
  {
    label: "Amazon",
    name: "amazon",
    color: "#FF9900"
  },
  {
    label: "Apple",
    name: "apple",
    color: "#000000"
  },
  {
    label: "Bandcamp",
    name: "bandcamp",
    color: "#629aa9"
  },
  {
    label: "Bluesky",
    name: "bluesky",
    color: "#0085FF"
  },
  {
    label: "Dev.to",
    name: "dev",
    color: "#000000"
  },
  {
    label: "Discord",
    name: "discord",
    color: "#7289da"
  },
  {
    label: "Dribbble",
    name: "dribbble",
    color: "#ea4c89"
  },
  {
    label: "Etsy",
    name: "etsy",
    color: "#d5641c"
  },
  {
    label: "Flickr",
    name: "flickr",
    color: "#FF0084"
  },
  {
    label: "Facebook",
    name: "facebook",
    color: "#3b5998"
  },
  {
    label: "GitHub",
    name: "github",
    color: "#333333"
  },
  {
    label: "Google Play",
    name: "google-play",
    color: "#3bccff"
  },
  {
    label: "Instagram",
    name: "instagram",
    color: "#e1306c"
  },
  {
    label: "iTunes",
    name: "itunes",
    color: "#EA4CC0"
  },
  {
    label: "Kickstarter",
    name: "kickstarter",
    color: "#05CE78"
  },
  {
    label: "LinkedIn",
    name: "linkedin",
    color: "#0077b5"
  },
  {
    label: "Medium",
    name: "medium",
    color: "#00ab6c"
  },
  {
    label: "Patreon",
    name: "patreon",
    color: "#FF424D"
  },
  {
    label: "Pinterest",
    name: "pinterest",
    color: "#BD081C"
  },
  {
    label: "Reddit",
    name: "reddit",
    color: "#FF4500"
  },
  {
    label: "Slack",
    name: "slack",
    color: "#4A154B"
  },
  {
    label: "Snapchat",
    name: "snapchat",
    color: "#FFFC00"
  },
  {
    label: "Spotify",
    name: "spotify",
    color: "#1DB954"
  },
  {
    label: "Soundcloud",
    name: "soundcloud",
    color: "#FE5000"
  },
  {
    label: "Steam",
    name: "steam",
    color: "#171a21"
  },
  {
    label: "Telegram",
    name: "telegram",
    color: "#0088cc"
  },
  {
    label: "TikTok",
    name: "tiktok",
    color: "#EE1D52"
  },
  {
    label: "Tumblr",
    name: "tumblr",
    color: "#34526f"
  },
  {
    label: "Twitch",
    name: "twitch",
    color: "#9147fe"
  },
  {
    label: "Twitter",
    name: "twitter",
    color: "#0c85d0"
  },
  {
    label: "X",
    name: "x-twitter",
    color: "#000000"
  },
  {
    label: "YouTube",
    name: "youtube",
    color: "#cc0000"
  }
]
